export default __webpack_public_path__ + "static/media/blackstar.41bc81d7.svg";